import { styled } from 'styled-components';

import { ButtonOrLink } from 'components/ButtonOrLink/ButtonOrLink';
import { colors, transition } from 'theme/theme';

export const TabsItemLi = styled.li`
  list-style: none;
  user-select: none;
  display: inline-block;
  margin: 0;
  padding: 0;
`;

export const TabsItemButtonOrLink = styled(ButtonOrLink)`
  font-size: inherit;
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  color: ${colors.lightContentGrey};
  transition: ${transition};

  &[data-variant='background'] {
    display: flex;
    align-items: center;
    height: 38px;
    padding-left: 24px;
    padding-right: 24px;
    font-size: 14px;

    &[aria-selected='true'] {
      background: ${colors.softBlue};
      color: ${colors.brandBlue};
    }
  }

  &[data-variant='marker'],
  &[data-variant='compact-marker'] {
    border-bottom: 2px solid transparent;

    &:hover {
      border-bottom: 2px solid ${colors.lightContentGrey};
    }

    &[aria-selected='true'] {
      color: ${colors.brandBlue};
    }
  }

  &[data-variant='marker'] {
    height: 47px;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  &[data-variant='compact-marker'] {
    padding-bottom: 8px;
  }
`;
